<template>
  <div
    class="poz_rel overflow-hidden"
    :style="{
      '--color': colorSchema,
      '--borderColor': borderColor,
      '--textColor': textColor,
      '--inputBacgroundColor': inputBacgroundColor,
      '--controlsBackground': controlsBackground
    }"
  >
    <div
      class="wrapper_file_upload"
      :style="{
        display: selectedFile ? 'none' : 'flex'
      }"
      :class="{ highlight: highlight }"
      @dragover.prevent
      @drop.stop.prevent="handleDrop"
      @dragenter.stop.prevent="onDragEnter"
      @dragleave.stop.prevent="onDragLeave"
    >
      <label class="file_upload">
        <input
          :disabled="hasUnresolvedDependencies"
          accept="image/*, application/pdf"
          id="uploaded-file"
          class="uploaded-file"
          type="file"
          name="file"
          ref="image"
          @change="onFilePicked"
        />
        <div class="upload_content">
          <h3>
            Incarca bonul <br />
            fiscal/factura
          </h3>
          <span class="d-none d-lg-block"
            >Trage si plaseaza imaginea sau fa click aici</span
          >
        </div>
        <button-component
          id="button"
          text="Incarca"
          :addClass="buttonClass"
          method="selectAnother"
        />
      </label>
    </div>

    <div v-show="!!selectedFile" class="wrapper_file_upload">
      <receipt-scanner
        :key="attempts"
        v-model="receipt"
        class="receipt-scanner"
        :apiUrl="apiUrl"
        ref="receiptScanner"
        :file="selectedFile"
        @input="onInput($event)"
        @uploadError="$emit('uploadError', $event)"
        v-bind="$props"
        :show="!!selectedFile"
        :controlsBackground="colorSchema"
        :cropColor="cropColor"
        :buttonClass="buttonClass"
        :textColor="textColor"
      >
        <template slot="crop">
          <span :title="cropTitle" v-b-tooltip>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="feather feather-crop"
            >
              <path d="M6.13 1L6 16a2 2 0 0 0 2 2h15" />
              <path d="M1 6.13L16 6a2 2 0 0 1 2 2v15" />
            </svg>
          </span>
        </template>
        <template slot="erase">
          <span :title="eraseTitle" v-b-tooltip>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="feather feather-edit-2"
            >
              <path
                d="M17 3a2.828 2.828 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z"
              />
            </svg>
          </span>
        </template>
        <template slot="drag">
          <span :title="dragTitle" v-b-tooltip>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="feather feather-move"
            >
              <polyline points="5 9 2 12 5 15" />
              <polyline points="9 5 12 2 15 5" />
              <polyline points="15 19 12 22 9 19" />
              <polyline points="19 9 22 12 19 15" />
              <line x1="2" y1="12" x2="22" y2="12" />
              <line x1="12" y1="2" x2="12" y2="22" />
            </svg>
          </span>
        </template>
        <template slot="zoomIn">
          <span :title="zoomInTitle" v-b-tooltip>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="feather feather-plus"
            >
              <line x1="12" y1="5" x2="12" y2="19"></line>
              <line x1="5" y1="12" x2="19" y2="12"></line>
            </svg>
          </span>
        </template>
        <template slot="zoomOut">
          <span :title="zoomOutTitle" v-b-tooltip>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="feather feather-minus"
            >
              <line x1="5" y1="12" x2="19" y2="12"></line>
            </svg>
          </span>
        </template>
      </receipt-scanner>
    </div>
  </div>
</template>

<script>
import { ReceiptScanner } from "../receipt-editor";
import "@/assets/styles/receipt-editor.css";
import ButtonComponent from "./button-component.vue";
import axios from "axios";
// import QueryStringToState from './query-string-to-state.vue';

export default {
  name: "receipt-processor",
  components: {
    ReceiptScanner,
    ButtonComponent
  },
  data() {
    return {
      receipt: null,
      apiUrl: "https://receipt.justsnap.eu", // api that will be used to retrieve "image points"
      selectedFile: null,
      processedFile: null,
      uploadSectionHover: false,
      highlight: false,
      attempts: 0,
      selectedValidate: false,
      processedValidate: false
    };
  },
  props: {
    successAction: Object,
    fieldId: String,
    requires: {
      type: Array
    },
    phrases: {
      type: Array
    },
    cornerDetectionPhrases: {
      type: Array
    },
    hideEraser: {
      type: Boolean
    },
    hideZoomer: {
      type: Boolean
    },
    skipCornerDetection: {
      type: Boolean
    },
    eraseColor: {
      type: String
    },
    eraseSize: {
      type: Number
    },
    cropColor: {
      type: String
    },
    cropTitle: {
      type: String
    },
    eraseTitle: {
      type: String
    },
    dragTitle: {
      type: String
    },
    selectImageTitle: {
      type: String
    },
    selectAnotherTitle: {
      type: String
    },
    zoomInTitle: {
      type: String
    },
    zoomOutTitle: {
      type: String
    },
    controlsBackground: {
      type: String
    },
    postBillUrl: {
      type: String,
      default: "https://receipt.justsnap.eu/postBill"
    },
    colorSchema: {
      required: false,
      type: String,
      default: "#f3b238"
    },
    tokenName: {
      required: false,
      type: String,
      default: "token"
    },
    reUpload: {
      required: false,
      type: Boolean
    },
    texts: {
      required: false,
      type: Object,
      default: () => {}
    },
    campaignId: {
      required: false,
      type: String,
      default: ""
    },
    selected: [Blob, File],
    internalButton: {
      required: false,
      type: Boolean,
      default: false
    },
    buttonClass: {
      required: false,
      type: String,
      default: ""
    },
    borderColor: {
      required: false,
      type: String,
      default: ""
    },
    inputBacgroundColor: {
      required: false,
      type: String,
      default: "#fbfcfe"
    },
    textColor: {
      required: false,
      type: String,
      default: "#0f2967"
    }
  },
  watch: {
    processedFile(value) {
      this.processedValidate = !!value;
    },
    selectedFile(value) {
      this.selectedValidate = !!value;
    },
    isImageCorrect(val) {
      this.$eventHub.$emit("canProceedNext", val);
    }
  },
  mounted() {
    this.selectedFile = this.selected || null;
    this.$eventHub.$on("sendReceipt-event", this.send);
    this.$eventHub.$on("selectAnother", this.selectAnother);
  },
  beforeDestroy() {
    this.$eventHub.$off("sendReceipt-event", this.send);
  },
  computed: {
    isImageCorrect() {
      return this.processedValidate && this.selectedValidate;
    },
    hasUnresolvedDependencies() {
      return this.$store.getters.hasUnresolvedDependencies(this.requires);
    }
  },
  methods: {
    send() {
      if (!this.$store.getters.customerToken) {
        this.$store.dispatch("refreshTempId");
      }
      //send receipt then ->
      this.$store.dispatch("setComponentStatus", {
        component: this.fieldId,
        status: false
      });
      let tempCampaignId = false
      if(this.campaignId=='colgate-elixir-carrefour'){
        tempCampaignId='colgate-palmolive'
      }
      const data = {
        image: this.receipt,
        apiUrl: this.postBillUrl,
        customerToken: this.$store.getters.customerToken,
        campaignId: tempCampaignId?tempCampaignId:this.campaignId
      }; // receipt info

      if (this.reUpload) {
        data["receiptToken"] = this.$route.query[this.tokenName];
        data["customerToken"] = 1;
        data["campaignId"] = `${this.campaignId}-re`;
      }

      this.$store
        .dispatch("uploadReceipt", data)
        .then((r) => {
          if(this.campaignId=='colgate-elixir-carrefour'){
            axios.post('https://js-backend.justsnap.eu/api/colgate-elixir-carrefour',{
                receiptToken:r,
                customerToken:this.$store.getters.customerToken
            }).then(resp=>{
              if(resp.data.response){
                  if (this.internalButton) this.$refs.sendButton.loading = false;
                    const fn = this.successAction.fn;
                    const params = this.successAction.params;
                    this[fn](params, this);
              }
            })
          }else{
          if (this.internalButton) this.$refs.sendButton.loading = false;
          const fn = this.successAction.fn;
          const params = this.successAction.params;
          this[fn](params, this);
          }
        })
        .catch((err) => {
          this.$eventHub.$emit("done-event-trigger", {
            parent: this,
            status: true
          });

          this.$store.dispatch("setComponentStatus", {
            component: this.fieldId,
            status: true
          });
        });
    },
    onFilePicked(event) {
      const files = event.target.files || event.dataTransfer.files;
      this.handleFiles(files);
    },
    handleDrop(e) {
      let dt = e.dataTransfer;
      let files = dt.files;
      this.handleFiles(files);
    },
    handleFiles(files) {
      const maxfilesize = 1024 * 1024 * 16; // 1 Mb
      this.$store.dispatch("setComponentStatus", {
        component: this.fieldId,
        status: false
      });

      if (files && files[0]) {
        let filename = files[0].name;

        if (filename && filename.lastIndexOf(".") <= 0) {
          return;
        }

        if (files[0].size > maxfilesize) {
          this.showModal(this.texts.fileSizeLimit);
          return;
        }
        const extension = files[0].name.split(".").pop();
        const found = ["png", "jpg", "jpe", "jpeg", "tiff", "pdf"].filter(
          (ext) => ext === extension.toLowerCase()
        );
        if (!found.length) {
          this.showModal(this.texts.wrongFormat);
          return;
        }
        this.attempts++;
        this.$nextTick().then(() => {
          this.selectedFile = files[0];
          this.processedFile = null;
        });
      }
    },
    onDragEnter() {
      this.highlight = true;
    },
    onDragLeave() {
      this.highlight = false;
    },
    onInput(data) {
      // this.$emit("component-updated", data);
      this.$store.dispatch("setComponentStatus", {
        component: this.fieldId,
        status: true
      });
      this.processedFile = data;
      this.$emit("component-updated", {
        selected: data
      });
    },
    selectAnother() {
      this.$refs.image.click();
    }
  }
};
</script>

<style scoped lang="scss">
* {
  font-family: "Plus Jakarta Sans";
}
.fade-enter-active,
.fade-leave-active {
  opacity: 1;
  transition: 0.4s;
}
.uploadIcon {
  position: absolute;
  top: 0;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.file_upload input[type="file"] {
  display: none;
}
.hidden {
  display: none;
}
.receipt-uploader {
  overflow: hidden;
}

.receipt-scanner ::v-deep {
  width: 100%;
  height: 100%;
  background-color: #fbfcfe;
  border: 1px dashed var(--borderColor);
  .layout > .container {
    border: 0;
    padding: 0;
  }
  .canvas-container {
    > div {
      display: flex;
      flex-direction: column;

      &:first-child {
        padding: 20px;
      }

      .controls {
        order: -1;
        border-radius: 6px 6px 0 0;

        .btn-group {
          display: flex;
          justify-content: space-between;
          width: 90%;

          @media (max-width: 767px) {
            width: 100%;
          }

          label {
            flex-basis: 44px;
            flex-grow: 0;
            flex-shrink: 0;
            height: 38px;
            background-color: #ffffff;
            box-shadow: 0px 4px 8px #eff3fb;
            border-radius: 2px;

            &:hover,
            &.active {
              border: 1px solid var(--controlsBackground);;
            }

            &.active {
              background: var(--controlsBackground);
              span {
                color: #fff;
              }
            }
          }

          .btn {
            border: 1px solid #ffffff;
            text-transform: uppercase;
            cursor: pointer;
            padding: 0.375rem 0.375rem;

            span {
              color: var(--color);
              width: 100%;
              height: 100%;
            }
          }
        }
      }

      .scanner-bar {
        background: #4f4f4f;
        box-shadow: 0 0 10px #4f4f4f;
      }

      .text {
        p {
          transform: translate(-50%, 0%);
        }
      }
    }
  }
}

.inputfile {
  width: 0.1px;
  height: 0.1px;
  opacity: 0;
  overflow: hidden;
  position: absolute;
  z-index: -1;
}

.poz_rel {
  position: relative;
  padding-bottom: 40px;
}
.receipt-widget {
  border-radius: 8px;
  position: relative;
  height: 100%;
  background-color: #fff;

  .btn_abs {
    z-index: 1000;
  }
}
.wrapper_file_upload {
  position: relative;
  height: 527px;
  background-color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-bottom: 20px;
  border-radius: 8px;
  box-shadow: 0px 16px 32px -3px #e2e8f9;
  border-radius: 16px;
  padding: 25px;
  transition: background-color 300ms;
  &_prog {
    border-style: solid;
  }
  @media (max-width: 767px) {
    height: 480px;
    padding: 20px;
  }
  .file_upload {
    height: 100%;
    width: 100%;
    cursor: pointer;
    padding: 20px;
    background-color: var(--inputBacgroundColor);;
    border: 1px dashed var(--borderColor);
    box-sizing: border-box;
    border-radius: 8px;
    margin: 0;
    position: relative;

    .upload_content {
      position: absolute;
      top: 20%;
      span {
        color: var(--textColor);
      }
    }
    #button {
      position: absolute;
      bottom: 5%;
      left: calc(50% - 63px);
      height: 45px;
      font-weight: 700;
    }
  }
}
.upload_img {
  width: 129px;
  margin-bottom: 30px;
}
.file_upload input[type="file"] {
  display: none;
}
.btn_abs {
  position: absolute;
  height: 40px;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  justify-content: center;
  align-items: center;
  font: normal normal medium 18px/24px Amberly Sans;

  @media (max-width: 767px) {
    font-size: 14px !important;
  }
}
.btn {
  text-align: center;
  background-color: #fff;
  vertical-align: middle;
  cursor: pointer;
  color: var(--brand-color3);
  user-select: none;
  transition: all 0.3s;
  border-radius: 8px;
  box-sizing: border-box;
  font-family: "Plus Jakarta Sans";
  background: transparent;
  font-size: 18px;
  font-weight: 500;
  padding: 10px 30px;
  box-shadow: none !important;
  border: 1px solid var(--brand-color3);
  &.disabled {
    opacity: 0.3;
  }
  &-lg {
    max-width: 470px;
    width: 100%;
  }
  &-md {
    max-width: 226px;
    width: 100%;
  }
  &-white {
    font-size: 16px;
    border-color: #ffffff;
    background-color: #ffffff;
    color: #1d1d1d !important;
    &:hover,
    &:focus {
      box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.16) !important;
    }
    &:active {
      border-color: #1d1d1d;
    }
  }
  &-green {
    border-color: var(--brand-color);
    background-color: var(--brand-color);
    color: #ffffff !important;
    &:hover,
    &:focus {
      box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.16) !important;
    }
    &:active {
      border-color: #028c86;
    }
  }
  &-light-blue {
    border-color: #beebe4;
    background-color: #beebe4;
    &:hover,
    &:focus {
      box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.16) !important;
    }
    &:active {
      border-color: var(--brand-color);
    }
  }
  &-transparent {
    max-width: 350px;
    border-color: #424242;
    color: #424242;
    &:hover,
    &focus {
      background-color: #424242;
      color: #ffffff;
    }
  }
}
.highlight {
  background-color: #c4f3f3;
}

.overflow-hidden {
  overflow: hidden;
}
</style>
